class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((cb) => cb(newContent));
    const wrap = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(wrap, newContent.outerHTML);
    const newNode = wrap.firstChild;
    oldNode.replaceWith(newNode);
    postProcessCallbacks?.forEach((cb) => cb(newNode));
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class QuantityInputDawn extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    else if (event.currentTarget.name === 'plus') this.showPurchaseLimitNotice();

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  // 구매수량 상한: + 를 눌렀는데 상한 때문에 더 오르지 않으면 재고 줄("In Stock") 옆에
  // 이유를 붙인다. 모바일은 담기 영역이 하단에 고정돼 안내 줄을 따로 둘 자리가 없어
  // 이 자리를 쓴다(데스크톱은 버튼 아래 안내 줄이 있어 CSS 로 숨김). 재고 줄은 변형
  // 전환 때 테마가 다시 그리므로 그때 사라지고, 다시 막히면 다시 붙는다.
  showPurchaseLimitNotice() {
    const limit = parseInt(this.input.dataset.purchaseLimit);
    const scope = this.closest('product-info') || document;
    if (Number.isNaN(limit)) {
      // 상한 없는 변형으로 바뀌면 남아 있는 안내를 지운다.
      scope.querySelectorAll('.stock-status .ab-limit-notice, .stock-status .ab-limit-pipe').forEach((el) => el.remove());
      return;
    }
    const inCart = parseInt(this.input.dataset.cartQuantity) || 0;
    const text = inCart > 0 ? `Limit ${limit} per order · ${inCart} in cart` : `Limit ${limit} per order`;
    // PC 안내 줄(.product-form__purchase-limit)과 같은 모양: 같은 클래스 + 같은 ⓘ 아이콘,
    // 상한까지 이미 담았으면 경고색(is-reached). 아이콘은 PC 줄에 렌더된 것을 복제한다.
    const icon = scope.querySelector('.product-form__purchase-limit svg');
    scope.querySelectorAll('.stock-status .ab-stock.in-stock').forEach((stock) => {
      let notice = stock.querySelector('.ab-limit-notice');
      if (!notice) {
        const pipe = document.createElement('span');
        pipe.className = 'ab-pipe ab-limit-pipe';
        pipe.textContent = '|';
        notice = document.createElement('span');
        notice.className = 'ab-limit-notice product-form__purchase-limit-inner';
        notice.setAttribute('role', 'status');
        if (icon) notice.append(icon.cloneNode(true));
        notice.append(document.createElement('span'));
        stock.append(pipe, notice);
      }
      notice.classList.toggle('is-reached', inCart >= limit);
      notice.lastElementChild.textContent = text;
    });
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input-dawn', QuantityInputDawn);

class ProductVariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      const selectedOptionValues = this.getSelectedOptionValueIds();
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: { event, target, selectedOptionValues },
      });
    });
  }

  getSelectedOptionValueIds() {
    const ids = [];
    this.querySelectorAll('select').forEach((sel) => {
      const opt = sel.selectedOptions[0] || sel.options[sel.selectedIndex] || null;
      const id = opt?.dataset?.optionValueId || null;
      if (id) ids.push(id);
    });
    this.querySelectorAll('fieldset input[type="radio"]:checked').forEach((inp) => {
      const id = inp?.dataset?.optionValueId || null;
      if (id) ids.push(id);
    });
    return ids;
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const prev = Array.from(target.options).find((option) => option.hasAttribute('selected'));
      if (prev) prev.removeAttribute('selected');

      const newSelectedOption = Array.from(target.options).find((option) => option.value === value);
      if (newSelectedOption) newSelectedOption.setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        ?.querySelector('[data-selected-value] > .product-option__swatch');
      if (!selectedDropdownSwatchValue) return;

      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('product-option__swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('product-option__swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`)?.querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }
}
customElements.define('product-variant-selects', ProductVariantSelects);

function _variantsJSON(root = document) {
  const el = root.querySelector('product-variant-selects [data-all-variants]');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent || el.innerHTML || '[]');
  } catch {
    return [];
  }
}

function _resolveVariantId(selectedOptionValues, root = document) {
  const variants = _variantsJSON(root);
  if (!variants.length) return null;

  const key = selectedOptionValues.slice().sort().join('-');
  for (const v of variants) {
    const ids = (v.option_value_ids || v.optionValues || v.options)?.slice()?.sort()?.join('-');
    if (ids === key) return v.id || v.variant_id;
  }

  const selects = Array.from(root.querySelectorAll('product-variant-selects select'));
  if (selects.length) {
    const chosen = selects.map((s) => s.value);
    const hit = variants.find((v) => (v.options || []).every((opt, i) => opt === chosen[i]));
    return hit ? (hit.id || hit.variant_id) : null;
  }
  return null;
}

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
        this.productMediaGallery = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        this.productVariantSelects = this.querySelector('product-variant-selects');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        this.initUpdateMedia();
        if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {
          this.updateVariantMedia();
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push(() => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            // 드로어·카트 페이지 변경(source 'cart-items')은 상한 상품 PDP 만 다시 계산한다.
            // 일반 상품까지 반응하면 고객이 골라 둔 수량이 초기화되고 섹션 요청이 늘었다.
            if (event?.source === 'cart-items') {
              if (!this.quantityInput?.dataset.purchaseLimit) return;
              // 이 변형의 카트 수량이 그대로면(다른 상품만 바뀜) 고객이 고른 수량을 건드리지 않는다.
              const variantId = Number(this.productForm?.variantIdInput?.value);
              const items = event.cartData?.items;
              if (Array.isArray(items)) {
                const inCart = items
                  .filter((item) => item.variant_id === variantId)
                  .reduce((total, item) => total + item.quantity, 0);
                if (String(inCart) === String(this.quantityInput.dataset.cartQuantity)) return;
              }
              // 카트가 바뀌었으니 이전 담기 시도의 빨간 박스는 더 이상 맞지 않는다.
              this.productForm?.handleErrorMessage?.();
            }
            this.fetchQuantityRules();
          });
        }
      }

      initUpdateMedia() {
        const variantIdFromUrl =
          parseInt(
            window.location.search
              .split('?')
              .filter((item) => item.includes('variant='))[0]
              ?.split('=')[1]
          ) || null;
        if (!variantIdFromUrl) return;
        const variant = this.getSelectedVariant(this);
        if (!variant || !variantIdFromUrl) return;
        if (variant?.id === variantIdFromUrl) {
          this.updateMedia(variant?.featured_media?.id);
        }
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;

        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        const targetVariantId = _resolveVariantId(selectedOptionValues, this) || null;

        if (targetVariantId && this.dataset.updateUrl !== 'false') {
          const u = new URL(productUrl, window.location.origin);
          u.searchParams.set('variant', String(targetVariantId));
          history.replaceState({}, '', `${u.pathname}?${u.searchParams.toString()}`);
        }

        const baseUrl = this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage);
        const requestUrl = targetVariantId
          ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}variant=${targetVariantId}`
          : baseUrl;

        this.renderProductInfo({
          requestUrl,
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        // 옵션 전환 응답을 기다리는 동안 버튼이 disabled 가 되는데, sg-prd-detail.css 가
        // disabled 버튼을 숨겨서 모바일에서 버튼이 1초쯤 사라졌다. 로딩 중에만 보이게 표시한다.
        this.setVariantLoading(true);
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            this.setVariantLoading(false);
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            this.setVariantLoading(false);
          });
      }

      setVariantLoading(loading) {
        // 이미 품절(disabled·숨김)인 버튼은 로딩 중에도 숨긴 채 둔다 — 안 그러면 "매진" 버튼이 잠깐 보인다.
        this.querySelectorAll('.product-form__submit').forEach((button) =>
          button.classList.toggle('is-variant-loading', loading && !button.disabled)
        );
      }

      getSelectedVariant(node) {
        const selectedVariant = node.querySelector('product-variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        if (!shouldFetchFullPage) params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) params.push(`option_values=${optionValues.join(',')}`);
        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const productVariantSelects = html.querySelector('product-variant-selects');
        if (productVariantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, productVariantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updateVariantDiscountBadge(variant?.price, variant?.compare_at_price);
          this.updateVariantDetails(variant?.id);

          if (this.pickupAvailability && variant?.id) {
            this.pickupAvailability.dataset.variantId = variant.id;
            this.pickupAvailability.fetchAvailability(variant.id);
          }

          if (this.productMediaGallery && this.productMediaGallery.dataset.hideOtherVariantsMedia === 'true') {
            this.updateVariantMedia(html);
          }

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = () => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (!source || !destination) return;

            destination.innerHTML = source.innerHTML;

            if (id === 'Inventory') {
              const th = parseInt(source.dataset.inventoryThreshold);
              const q = parseInt(source.dataset.inventoryQuantity);
              destination.classList.toggle('hidden', (th && q > th) || q < 1);
            } else {
              destination.classList.toggle('hidden', !!shouldHide(source));
            }
          };

          updateSourceFromDestination('ProductPurchaseInfo');
          updateSourceFromDestination('ProductStickyCart');
          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', (s) => s.classList.contains('hidden'));
          updateSourceFromDestination('Inventory', (s) => s.innerText === '');

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          this.productMediaGallery = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
          this.productVariantSelects = this.querySelector('product-variant-selects');

          this.productMediaGallery
            ?.querySelectorAll('swiper-product-gallery, swiper-product-thumbs')
            .forEach((el) => {
              if (el.init && !el.instance) el.init();
            });

          publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: this.sectionId, html, variant } });

          const skuSpans = this.querySelectorAll('[data-selected-sku]');
          if (skuSpans.length) {
            const skuText = variant && typeof variant.sku === 'string' ? variant.sku : '';
            skuSpans.forEach((el) => {
              el.textContent = skuText;
            });
          }
        };
      }

      updateVariantMedia() {
        const handle = this.querySelector(
          'product-variant-selects [data-selected-variant-options-handle]'
        )?.innerHTML?.trim();
        if (!handle) return;

        this.productMediaGallery.querySelectorAll('[data-media-group]').forEach((el) => el.classList.add('hidden'));
        this.productMediaGallery
          .querySelectorAll(`[data-media-group="${handle}"]`)
          .forEach((el) => el.classList.remove('hidden'));

        this.productMediaGallery.querySelectorAll('swiper-product-gallery').forEach((swiper) => {
          if (swiper.instance) swiper.instance.update();
          else if (swiper.init) swiper.init();
        });
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateSellingPlanURL(sellingPlanId, selectedVariantId) {
        if (!selectedVariantId) return;
        if (!sellingPlanId) {
          window.history.replaceState({}, '', `${window.location.href.replace(/&selling_plan=\d+/, '')}`);
        } else {
          const params = new URLSearchParams(window.location.search);
          params[params.has('variant') ? 'set' : 'append']('variant', selectedVariantId);
          if (sellingPlanId) {
            params[params.has('selling_plan') ? 'set' : 'append']('selling_plan', sellingPlanId);
          } else {
            params.delete('selling_plan');
          }
          window.history.replaceState({}, '', `${this.dataset.url}?${params.toString()}`);
        }
      }

      updateVariantDetails(variantId) {
        const productVariantDetails = this.querySelectorAll('.product__metafield_for_variant-block');
        if (!productVariantDetails?.length) return;
        productVariantDetails.forEach((productVariantDetail) => {
          const block_id = productVariantDetail.getAttribute('data-block-id');
          const metafieldDataElement = this.querySelector(`#product__metafield_for_variant-block--${block_id}`);
          if (!metafieldDataElement) return;
          try {
            const data = JSON.parse(metafieldDataElement?.textContent);
            productVariantDetail.innerHTML = data?.[variantId]?.replaceAll('\n', '<br />') || '';
          } catch {}
        });
      }

      updateVariantDiscountBadge(price, compare_at_price) {
        // 할인 배지에만 붙는 표식으로 찾는다. 클래스는 문자열에 '% OFF' 만 들어 있으면 붙어서
        // 운영자가 태그로 넣은 문구까지 걸린다. 표식이 없으면 클래스로 폴백한다.
        const marked = this.querySelectorAll('[data-discount-badge]');
        const badges = marked.length ? marked : this.querySelectorAll('.product-card__badge--discount');
        if (!badges.length) return;
        // 서버(product-badges.liquid)와 곱셈·나눗셈 순서를 맞춘다. 뒤집으면 x.5 로 떨어지는 조합에서 1%p 어긋난다
        const pct = compare_at_price > price ? Math.round(((compare_at_price - price) * 100) / compare_at_price) : 0;
        // 서버가 배지를 그리는 최소 할인율 기준
        const minPct = Number(this.dataset.badgeMinPercent) || 0;
        badges.forEach((badge) => {
          if (pct > 0 && pct >= minPct) {
            badge.classList.remove('hidden');
            const el = badge.querySelector('.percentage');
            if (el) el.textContent = pct;
            else badge.textContent = `${pct}% OFF`;
          } else {
            badge.classList.add('hidden');
          }
        });
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);
        const selectors = ['price', 'Inventory', 'Sku', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const gridLayout = this.querySelector('.main-product__media--grid');
        if (gridLayout) {
          gridLayout.querySelectorAll('.swiper-slide').forEach((item) => item.classList.remove('active'));
          const activeSlide = gridLayout.querySelector(`.swiper-slide[data-media-id="${variantFeaturedMediaId}"]`);
          if (activeSlide) activeSlide.classList.add('active');
        }

        if (this.querySelector('.main-product__media')?.hasAttribute('data-desktop-grid') && window.innerWidth >= 750) {
          this.scrollToImage(variantFeaturedMediaId);
        }

        const productMedia = this.querySelector('swiper-product-gallery');
        productMedia?.setActiveMedia(variantFeaturedMediaId);
      }

      scrollToImage(variantFeaturedMediaId) {
        this.querySelectorAll('[data-media-id]').forEach((img) => {
          if (img.getAttribute('data-media-id') == variantFeaturedMediaId) {
            img.scrollIntoView({ block: 'end', behavior: 'smooth' });
          }
        });
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        let max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        // 카트에 이미 상한만큼 있으면 max 가 0 이 된다. 예전 `if (max)` 는 0 을 "없음"으로
        // 보고 max 를 지워 + 가 무제한으로 올라갔다.
        // 상한 상품은 남은 수량 0 을 그대로 둔다(예전 `if (max)` 는 0 을 "없음"으로 보고
        // max 를 지워 + 가 무제한이 됐다). 상한 없는 상품은 원래 동작을 유지한다.
        const hasPurchaseLimit = !!this.quantityInput.dataset.purchaseLimit;
        if (max !== null) max = Math.max(max, 0);
        this.quantityInput.min = min;
        if (max !== null && (max > 0 || hasPurchaseLimit)) this.quantityInput.max = max;
        else this.quantityInput.removeAttribute('max');
        this.quantityInput.value = min;

        // 상한까지 이미 담았으면 담기 버튼을 흐리게 한다. disabled 는 변형 전환 때
        // 재고 기준으로 테마가 다시 정하므로 건드리지 않고, 누르면 이유를 보여준다.
        // product-form 이 아직 업그레이드 전일 수 있어(정의 순서상 product-info 가 먼저 연결됨)
        // 속성 대신 DOM 에서 바로 찾는다.
        this.querySelector('.product-form__submit')?.classList.toggle(
          'is-limit-reached',
          max === 0 && hasPurchaseLimit
        );

        // 모바일: 상한 안내를 처음부터 재고 줄("In Stock") 옆에 띄운다(데스크톱은 CSS 로 숨김).
        this.quantityInput.closest('quantity-input-dawn')?.showPurchaseLimitNotice?.();

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            // 그 사이 변형을 바꿨으면 이전 변형 규칙으로 덮지 않는다.
            if (this.productForm?.variantIdInput?.value !== currentVariantId) return;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch(() => {})
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner')?.classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;

        const purchaseLimitUpdated = html.getElementById(`PurchaseLimit-${sectionId}`);
        const purchaseLimitCurrent = this.querySelector('.product-form__purchase-limit');
        if (purchaseLimitUpdated && purchaseLimitCurrent) purchaseLimitCurrent.innerHTML = purchaseLimitUpdated.innerHTML;

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        if (!quantityFormUpdated) return this.setQuantityBoundries();
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'data-purchase-limit', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
              else current.removeAttribute(attribute);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }

        // 새 변형의 data-* 를 받은 뒤에 경계를 계산해야 변형별 상한·카트 수량이 맞는다.
        this.setQuantityBoundries();
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('product-variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(SectionId.parseId(this.sectionId), 'related-products');
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(SectionId.parseId(this.sectionId), 'quick_order_list');
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // 구매수량 상한: (카트 수량 + 입력) 이 상한을 넘으면 서버에 보내기 전에 막고
        // 무엇이 문제인지 그대로 말한다. 서버 문구("reduce the quantity to continue")는
        // 화면 수량이 1일 때도 나와 무엇을 줄이라는지 알 수 없었다.
        // 카트 수량은 렌더 시점 data-cart-quantity 가 담기·드로어 변경 뒤 갱신되지 않아
        // 담기 직전에 /cart.js 로 다시 센다.
        const qtyInput = this.form.querySelector('[name="quantity"]') ||
          document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
        const limit = qtyInput ? parseInt(qtyInput.dataset.purchaseLimit) : NaN;
        if (qtyInput && !Number.isNaN(limit)) {
          const variantId = Number(this.variantIdInput.value);
          const wanted = parseInt(qtyInput.value) || 0;
          fetch(`${routes.cart_url}.js`, { credentials: 'same-origin', cache: 'no-store' })
            .then((response) => response.json())
            .then((cart) =>
              cart.items
                .filter((item) => item.variant_id === variantId)
                .reduce((total, item) => total + item.quantity, 0)
            )
            .catch(() => parseInt(qtyInput.dataset.cartQuantity) || 0)
            .then((inCart) => {
              const stale = String(inCart) !== String(qtyInput.dataset.cartQuantity);
              qtyInput.dataset.cartQuantity = inCart;
              // 화면이 옛 카트 수량 기준(수량칸 0 등)이면, 실제로 담을 수 있을 때
              // 최소 1개는 담는다. 누른 의도가 "담기"이므로.
              if (stale && wanted < 1 && inCart < limit) {
                qtyInput.value = 1;
                return this.submitToCart();
              }
              if (inCart + wanted > limit || wanted < 1) {
                // 이미 상한만큼 담았으면, PC 는 버튼 아래 빨간 안내 줄이, 모바일은 재고 줄 옆 안내가
                // 같은 내용을 보여주므로 빨간 박스를 또 띄우지 않는다(중복). 둘 다 안 보일 때만 박스.
                if (inCart >= limit) {
                  const scope = this.closest('product-info') || document;
                  qtyInput.closest('quantity-input-dawn')?.showPurchaseLimitNotice?.();
                  // offsetParent 는 fixed 영역(모바일 하단 고정 바) 안에서 항상 null 이라 쓰지 않는다.
                  const visible = (el) =>
                    !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
                  if (
                    // 재고 줄 안내도 같은 클래스를 써서 DOM 순서상 먼저 잡히므로, PC 안내 줄은 부모로 한정한다.
                    visible(scope.querySelector('.product-form__purchase-limit .product-form__purchase-limit-inner.is-reached')) ||
                    [...scope.querySelectorAll('.ab-limit-notice')].some(visible)
                  ) {
                    return;
                  }
                }
                this.handleErrorMessage(
                  inCart >= limit
                    ? `This item is limited to ${limit} per order, and you already have ${inCart} in your cart.`
                    : `This item is limited to ${limit} per order. You already have ${inCart} in your cart, so you can add ${limit - inCart} more.`
                );
                return;
              }
              this.submitToCart();
            });
          return;
        }

        this.submitToCart();
      }

      submitToCart() {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        // 버튼 안의 스피너를 켠다. this.querySelector 로 찾으면 문서 순서상 먼저 오는
        // 수량칸 라벨(visually-hidden) 안의 스피너를 집어, 화면에는 아무 표시도 나지
        // 않는다. 담기 응답이 2초 가까이 걸리는데 그동안 버튼이 그대로라 눌렸는지
        // 알 수 없었다. 없을 때를 대비해 기존 경로를 폴백으로 남긴다.
        this.loadingSpinner =
          this.loadingSpinner ||
          this.submitButton.querySelector('.loading__spinner') ||
          this.querySelector('.loading__spinner');
        if (this.loadingSpinner) this.loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.section)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.__a11yAnnounceCartAdd = false;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            window.__a11yAnnounceCartAdd = true; // A11Y-2 (WCAG 4.1.2): announced once the counters refresh
            this.cart.renderContents(response);
          })
          .catch(() => {})
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.loadingSpinner) this.loadingSpinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = this.hasAttribute('data-has-selling-plan')
            ? window.variantStrings.addSubscriptionToCart
            : this.hasAttribute('data-has-pre-order')
            ? window.variantStrings.preOrder
            : window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

document.querySelectorAll('.product__content > *').forEach((el) => {
  if (!el.textContent.trim()) el.textContent = '';
});

//ksj-260209
subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  const v = data.variant;
  const sectionId = data.sectionId;

  /* ===============================
    1. Variant notice MAP
  =============================== */
  const mapEl = document.getElementById('VariantSaveNoticeMap');
  const variantNoticeMap = mapEl
    ? JSON.parse(mapEl.textContent.trim())
    : {};

  const variantNotice = variantNoticeMap[v.id] || '';

  /* ===============================
    2. Product notice (JSON)
  =============================== */
  const productNoticeEl = document.getElementById('ProductSaveNotice');
  let productNotice = '';
  if (productNoticeEl) {
    try {
      productNotice = JSON.parse(
        productNoticeEl.textContent.trim()
      ) || '';
    } catch (e) {
      productNotice = '';
    }
  }

  /* ===============================
    3. 최종 notice 결정
  =============================== */
  const noticeText = variantNotice || productNotice || '';

  /* ===============================
    4. 품절 판단
  =============================== */
  const soldOutByVariant =
    typeof v?.available === 'boolean'
      ? !v.available
      : typeof v?.available_for_sale === 'boolean'
      ? !v.available_for_sale
      : null;

  /* ===============================
    5. HTML 템플릿
  =============================== */
  const OUT_HTML = `
    <div class="ab-stock out-of-stock">
      <span style="border-radius:50%;overflow:hidden;">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="9" r="8" fill="white" stroke="#AAAAAA" stroke-width="2"></circle>
          <path d="M16.5 16.5L1.5 1.5" stroke="#AAAAAA" stroke-width="2"></path>
        </svg>
      </span>
      <b>Out of Stock</b>
      <span class="ab-pipe">|</span>
      Get a restock notification via email
    </div>
  `;

  const buildInHtml = (notice = '') => `
    <div class="ab-stock in-stock">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="9" r="9" fill="#F4F5FE"></circle>
          <circle cx="9" cy="9" r="4" fill="#193B7E"></circle>
        </svg>
      </span>
      <b>In Stock</b>
      ${notice ? `<span class="ab-pipe">|</span>${notice}` : ``}
    </div>
  `;

  /* ===============================
    6. 렌더
  =============================== */
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const productInfo = document.querySelector('.product__variant-picker');
      if (!productInfo) return;

      const submitBtn =
        productInfo.querySelector(`#ProductSubmitButton-${sectionId}`) ||
        document.querySelector(`#ProductSubmitButton-${sectionId}`);

      const uiDisabled = submitBtn?.hasAttribute('disabled') ?? false;
      const isSoldOut =
        soldOutByVariant !== null ? soldOutByVariant : uiDisabled;

      const stockEls = productInfo.querySelectorAll('.stock-status');
      if (!stockEls.length) return;

      stockEls.forEach((wrap) => {
        wrap.innerHTML = isSoldOut
          ? OUT_HTML
          : buildInHtml(noticeText);
      });
      // 재고 줄을 새로 그리면 모바일 상한 안내가 지워지므로 다시 붙인다.
      if (!isSoldOut) document.querySelector('product-info quantity-input-dawn')?.showPurchaseLimitNotice?.();
    });
  });
});